import React, { useState } from 'react';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Tooltip,
    IconButton,
    Box, Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Close';

export default function EditableTable({headers, data, onDataChange, cellTemplates, getNewRow, title}) {
    const [rows, setRows] = useState(data);
    const [editableRow, setEditableRow] = useState(null);
    const [tempValues, setTempValues] = useState({});

    const handleRowClick = (row) => {
        if (editableRow !== null && editableRow !== row) {
            handleSaveClick(); // Save the current editable row before editing another
        }
        if (row === editableRow) return;
        setEditableRow(row);
        setTempValues({ ...row });
    };

    const handleSaveClick = () => {
        const updatedRows = rows.map((row) =>
            row === editableRow ? { ...tempValues } : row
        );
        setRows(updatedRows);
        onDataChange(updatedRows);
        setEditableRow(null);
        setTempValues({});
    };

    const handleCancelClick = () => {
        setEditableRow(null);
        setTempValues({});
    };

    const handleDeleteClick = (row) => {
        const updatedRows = rows.filter((r) => r !== row);
        setRows(updatedRows);
        onDataChange(updatedRows);
    };

    const handleAddClick = () => {
        if (editableRow !== null) {
            const updatedRows = rows.map((row) =>
                row === editableRow ? {...tempValues} : row
            );
            setRows(updatedRows);
            onDataChange(updatedRows);
        }
        const newRow = getNewRow ? getNewRow() : {id: null};
        const updatedRows = [...(editableRow ? rows.map((row) =>
            row === editableRow ? {...tempValues} : row) : rows), newRow];
        setRows(updatedRows);
        setEditableRow(newRow);
        setTempValues(newRow);
        onDataChange(updatedRows);
    };

    const handleInputChange = (field, value) => {
        console.log('handleInputChange:', field, value);
        setTempValues((prev) => {
            const newValues = {
                ...prev,
                [field]: value,
            };
            console.log('New tempValues:', newValues);
            return newValues;
        });
    };


    return (
        <Box>
            <Box sx={{ display: 'flex', mt: 2, alignItems: 'center' }}>
                <Typography variant="h6">{title}</Typography>
                <IconButton color="primary" onClick={handleAddClick}>
                    <AddIcon />
                </IconButton>
            </Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell key={index}>{header}</TableCell>
                            ))}
                            <TableCell align="right">Acciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow
                                key={row.id}
                                onClick={(e) => {
                                    // Only handle click if it's directly on the row, not on child elements
                                    if (e.target === e.currentTarget || e.target.tagName === 'TD') {
                                        handleRowClick(row);
                                    }
                                }}

                                sx={{ cursor: 'pointer' }}
                            >
                                {Object.keys(cellTemplates).map((field) => (
                                    <TableCell key={field} sx={{ padding: 2 }}>
                                        {editableRow === row
                                            ? cellTemplates[field].edit(tempValues[field], (value) =>
                                                  handleInputChange(field, value)
                                              )
                                            : cellTemplates[field].read(row[field])}
                                    </TableCell>
                                ))}
                                <TableCell align="right" sx={{ padding: 2 }}>
                                    {editableRow === row ? (
                                        <Box sx={{display: 'flex'}}>
                                            <Tooltip title="Save">
                                                <IconButton onClick={handleSaveClick}>
                                                    <CheckIcon color="primary"/>
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Cancel">
                                                <IconButton onClick={handleCancelClick}>
                                                    <CancelIcon color="secondary"/>
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    ) : (
                                        <Tooltip title="Delete">
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent row click
                                                    handleDeleteClick(row);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
